import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { useNotification } from "../../context/NotificationContext";
import { useClient } from "../../context/ClientContext";
import AuthService from "../../services/AuthService";

interface TopBannerProps {
  title?: string;
  addButtonName?: string;
  useBackButton?: boolean;
  hideAdd?: boolean;
  loading?: boolean;
  addPermission?: string[];
  onAddClicked?: () => void;
}

const TopBanner: React.FC<TopBannerProps> = ({
  title = "",
  addButtonName = "Create",
  addPermission = [],
  onAddClicked,
  loading = false,
  hideAdd = false,
  useBackButton = true,
}) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const notification = useNotification();
  const client = useClient("AUTH_SERVICE");
  const authService = new AuthService(client, notification);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="w-full flex flex-col px-4 py-2">
      <div
        className={`flex items-center justify-between  px-4 py-2 ${
          theme === "night" ? "bg-gray-700" : "bg-primary-100"
        }  rounded-3xl`}
      >
        {(title || useBackButton) && (
          <div className="flex items-center">
            {useBackButton && (
              <button
                className={`flex items-center rounded-full p-2 
                                ${
                                  theme === "night"
                                    ? "hover:bg-gray-500 text-gray-50"
                                    : "hover:bg-gray-200 text-gray-700"
                                }`}
                onClick={goBack}
                title="Go Back"
              >
                <span className="material-icons">arrow_back</span>
              </button>
            )}
            {title && (
              <span
                className={`text-lg font-semibold tracking-wider ${
                  theme === "night" ? "text-gray-50" : "text-gray-700"
                } truncate hidden sm:inline`}
              >
                {title}
              </span>
            )}
          </div>
        )}

        {!hideAdd &&
          addPermission.length > 0 &&
          authService.hasPermission(addPermission) && (
            <div className="flex">
              <button
                onClick={onAddClicked}
                className={`flex items-center py-2 px-4 rounded-full sm:hidden 
                            ${
                              theme === "night"
                                ? "text-gray-50"
                                : "text-gray-800"
                            } 
                            bg-primary hover:bg-primary-600`}
              >
                <span className="material-icons">add_circle_outline</span>
              </button>

              <button
                onClick={onAddClicked}
                className={`hidden sm:flex items-center gap-x-2 py-2 px-4 rounded-full 
                            ${
                              theme === "night"
                                ? "text-gray-50"
                                : "text-gray-800"
                            } 
                            bg-primary hover:bg-primary-600`}
              >
                <span className="material-icons">add_circle_outline</span>
                {addButtonName}
              </button>
            </div>
          )}
      </div>

      {loading && (
        <div className="w-full h-1 bg-blue-500 animate-pulse mt-2"></div>
      )}
    </div>
  );
};

export default TopBanner;
